import { useSnackbar } from '@/hooks/useSnackbar';
import { useState } from 'react';
import {
  adicionarFichaAPlaylist,
  favoritarFicha,
  verDepoisFicha,
} from '@/services/playlistsService';
import {
  ArgumentosAdicionarFichaAPlaylist,
  ArgumentosFavoritarFicha,
  ArgumentosVerDepoisFicha,
} from '@/services/types/playlists';
import { useHomeData } from './useHomeData';

function usePlaylistsHook() {
  const [loading, setLoading] = useState(false);
  const { mostrarSnackbar } = useSnackbar();
  const { recuperarListasUsuario } = useHomeData();

  async function adicionarPlaylist(props: ArgumentosAdicionarFichaAPlaylist) {
    try {
      setLoading(true);
      const response = await adicionarFichaAPlaylist(props);

      if (response.sucesso === false) {
        throw new Error(response.mensagem);
      }

      await recuperarListasUsuario({});

      return response;
    } catch (error: unknown) {
      if (error instanceof Error) {
        mostrarSnackbar({
          color: 'error',
          highContrast: true,
          mensagem: error.message ?? '',
          size: 1,
          variant: 'solid',
        });
      }
    } finally {
      setLoading(false);
    }
  }

  async function adicionarVerDepois(props: ArgumentosVerDepoisFicha) {
    try {
      setLoading(true);
      const response = await verDepoisFicha(props);

      if (response.sucesso === false) {
        throw new Error(response.mensagem);
      }

      recuperarListasUsuario({});

      return response;
    } catch (error: unknown) {
      if (error instanceof Error) {
        mostrarSnackbar({
          color: 'error',
          highContrast: true,
          mensagem: error.message ?? '',
          size: 1,
          variant: 'solid',
        });
      }
    } finally {
      setLoading(false);
    }
  }

  async function adicionarFavorito(props: ArgumentosFavoritarFicha) {
    try {
      setLoading(true);
      const favoritarResponse = await favoritarFicha({ ...props });

      if (favoritarResponse.sucesso === false) {
        throw new Error(favoritarResponse.mensagem);
      }

      recuperarListasUsuario({});

      return favoritarResponse;
    } catch (error: unknown) {
      if (error instanceof Error) {
        mostrarSnackbar({
          color: 'error',
          highContrast: true,
          mensagem: error.message ?? '',
          size: 1,
          variant: 'solid',
        });
      }
    } finally {
      setLoading(false);
    }
  }

  return {
    adicionarPlaylist,
    adicionarVerDepois,
    adicionarFavorito,
    loading,
  };
}

export type usePlaylistsHookType = ReturnType<typeof usePlaylistsHook>;

export default usePlaylistsHook;
